import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, Resolve, RouterStateSnapshot} from '@angular/router';
import { OrganizationParameter, ProviderItem} from '../../../utils/objects/organization-parameter';
import {ApiService} from '../../../utils/services/api.service';
import {Observable} from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import {PROVIDER_TYPES} from '../../../utils/constants/constants';

@Injectable()
export class ProviderResolverService implements Resolve<any> {

  constructor(private apiService: ApiService) {
  }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): any {
    let organizationID = route.parent.params.id;
    let providers = [];

    return this.apiService.getOrganizationParameters(organizationID).map(
      (response) => {
        response['data'].rows.forEach((organizationParameter) => {

          if (PROVIDER_TYPES.includes(organizationParameter.type)) {
            let isProviderExists = false;
            providers.forEach((providerItem) => {
              if (providerItem.provider === organizationParameter.context) {
                isProviderExists = true;
                providerItem[organizationParameter.key] = organizationParameter;
              }
            });

            if (!isProviderExists) {
              let providerItem = new ProviderItem();
              providerItem.provider = organizationParameter.context;
              providerItem.id = organizationParameter.id;
              providerItem.type = organizationParameter.type;
              providerItem[organizationParameter.key] = organizationParameter;
              providers.push(providerItem);
            }
          }

        });
        return providers;
      }).catch((error) => {
      return Observable.of([]);
    });

  }

}



// WEBPACK FOOTER //
// C:/Biziclick/bizisystem/src/app/main/frames/resolvers/provider-resolver.service.ts